import * as types from '../constants/ActionTypes';

export const initialState = {
    homeworkId: [],
    disableFavouriteHomework: false
};

export default function favouriteHomework(state = initialState, action = {}) {
    switch (action.type) {
        case types.ADD_HOMEWORK_TO_FAVOURITE_SUCCESS:
            return {
                ...state,
                homeworkId: action.result
            };
        case types.ADD_HOMEWORK_TO_FAVOURITE_FAILURE:
            return {
                ...state
            };
        case types.REMOVE_HOMEWORK_FROM_FAVOURITE_SUCCESS:
            return {
                ...state,
                homeworkId: action.result
            };
        case types.REMOVE_HOMEWORK_FROM_FAVOURITE_FAILURE:
            return {
                ...state
            };
        case types.GET_FAVOURITE_HOMEWORK:
            return {
                ...state,
                disableFavouriteHomework: false
            };
        case types.GET_FAVOURITE_HOMEWORK_SUCCESS:
            return {
                ...state,
                homeworkId: action.result,
                disableFavouriteHomework: false
            };
        case types.GET_FAVOURITE_HOMEWORK_FAILURE:
            return {
                ...state,
                disableFavouriteHomework: true
            };
        default:
            return state;
    }
}
